module.exports = __webpack_public_path__ + "static/media/11NEPAD8.f3080666.jpg";